module.exports = __webpack_public_path__ + "img/banner-hen-en.178e4d2b.png";